import { useAtomValue } from 'jotai';
import { auditLogVersionAtom } from './atoms/structured-addresses';
import { ActivityLog } from './activity-log';
import { useDocumentActivityFeed } from './hooks';

interface DocumentAuditLogSectionProps {
  documentId: number;
}

/**
 * The document's activity log, newest first, refreshed whenever its activity may have changed.
 *
 * @param {DocumentAuditLogSectionProps} props - The document.
 * @return {JSX.Element} The log, or its loading, error or empty state.
 */
export function DocumentAuditLogSection({
  documentId,
}: DocumentAuditLogSectionProps) {
  const auditLogVersion = useAtomValue(auditLogVersionAtom);
  const activity = useDocumentActivityFeed({
    documentId,
    refreshToken: auditLogVersion,
  });

  return (
    <ActivityLog
      activity={activity}
      emptyMessage="No activity log entries yet for this document."
    />
  );
}
